module.exports = __webpack_public_path__ + "static/media/20ECE11.9396f919.jpg";